import type { LucideIcon } from 'lucide-react';
import { ClipboardList, LayoutGrid, ShieldCheck, Wrench, Zap } from 'lucide-react';
import type { Rol } from '@/types/api';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  // Rol mínimo para ver el ítem (mismo ranking que RequireRole/RequireAdmin:
  // viewer < gestor < admin). Sin minRol: visible para cualquier rol logueado.
  minRol?: Rol;
  // Badge de conteo a la derecha del label (expandido) o pastilla sobre el
  // ícono (colapsado). Hoy solo 'avivador' (useAvivadorBadge en sidebar.tsx,
  // context/design_avivador.md §2 punto 7 y §10 B3): oculto si 0 o sin datos.
  badge?: 'avivador';
}

export interface NavGroup {
  key: string;
  // Label que se ve arriba del grupo en el sidebar expandido (ej. "Solo
  // Administración"). Sin label: grupo "general", sin encabezado — mismo look que
  // el grupo de arriba de todo.
  label?: string;
  items: NavItem[];
}

// Grupos de navegación (decisión Juan 2026-07-10, ampliada 21/9 con el
// Avivador — context/design_avivador.md §2 punto 11): grupo general (Obras,
// Avivador) · grupo Gestión (gestor+admin) · grupo admin (Administración,
// Auditoría), este último PEGADO AL FONDO del sidebar (sidebar.tsx le aplica
// mt-auto), separado del resto por la misma línea de siempre. sidebar.tsx
// renderiza un separador ENTRE cada grupo visible, y el label solo para el
// que lo tenga (hoy, admin) — el filtrado por rol vive en sidebar.tsx via
// minRol.
export const NAV_GROUPS: NavGroup[] = [
  {
    key: 'general',
    items: [
      // Ícono de Obras: la grilla de 4 cuadrados del mockup aprobado (Juan, 2026-07-10).
      { to: '/', label: 'Obras', icon: LayoutGrid },
      // Avivador (21/9/2026, design_avivador.md): todos los roles lo ven (las
      // acciones ya están gateadas por rol en el backend y en la UI del
      // módulo, no acá); badge = conteo del filtro inicial de cada usuario.
      { to: '/avivador', label: 'Avivador', icon: Zap, badge: 'avivador' },
    ],
  },
  {
    key: 'gestion',
    items: [{ to: '/gestion', label: 'Gestión', icon: Wrench, minRol: 'gestor' }],
  },
  {
    key: 'admin',
    label: 'Sistema',
    items: [
      { to: '/administracion', label: 'Administración', icon: ShieldCheck, minRol: 'admin' },
      { to: '/auditoria', label: 'Auditoría', icon: ClipboardList, minRol: 'admin' },
    ],
  },
];
